const links = {
  MUSEUM: 'https://www.neprajz.hu/',
  ETNOSHOP: 'https://etnoshop.hu/',
  PIXELPERFECTAWARDS: 'https://ppawards.hu/2022/dijazottak.php',
  MUSEUMLEGALNOTICE: 'https://neprajz.hu/joginyilatkozat',
  MUSEUMTERMSOFUSE: 'https://neprajz.hu/felhasznalasifeltetelek',
}

export default links
